import { FontAwesomeIcon } from '../utils/lib';

export default FontAwesomeIcon;
